export const LINES = 'LINES';
export const WORDS = 'WORDS';
export const CHARS = 'CHARS';
